"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@emotion/core");

var react_1 = require("react");

exports.TextArea = react_1.forwardRef(function (_a, ref) {
  var rest = __rest(_a, []);

  return core_1.jsx("textarea", __assign({
    ref: ref,
    css: {
      appearance: 'none',
      background: 0,
      border: 0,
      boxSizing: 'border-box',
      color: 'inherit',
      display: 'inline-block',
      fontFamily: 'inherit',
      fontSize: '1rem',
      lineHeight: 'inherit',
      margin: 0,
      padding: 0,
      position: 'relative',
      verticalAlign: 'middle',
      WebkitTapHighlightColor: 'transparent',
      '::placeholder': {
        color: 'inherit',
        opacity: '0.5'
      },
      '&:disabled': {
        cursor: 'not-allowed'
      },
      '&:focus': {
        zIndex: 1
      }
    }
  }, rest));
});